<template>
    <div class="main bbt-main bbt-main">
        <div class="book-module">
            <div class="bbt-container">
                <div class="book-module__group bbt-clearfix">
                    <div class="book-module__package">
                        <div class="book-module__thumb">
                            <div class="front">
                                <img :src="book.bookCover">
                            </div>
                            <!-- <div class="side" style="background-image:url(https://cdn.8btc.com/wp-content/uploads/2019/07/201907180706182059.jpg);"></div> -->
                        </div>
                    </div>
                    <div class="book-module__info">
                        <h2>{{book.bookName}}</h2>
                        <p>
                            {{book.descriptions}}
                        </p>
                        <div>
                            <a :href="book.saleLink" target="_blank" class="bbt-btn bbt-btn--primary">立即购买</a>
                            <!-- <a href="https://book.8btc.com/books/6/blockchain-ten-year/_book/" target="_blank" class="bbt-btn bbt-btn-ghost--primary">立即试读</a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'BookDetail',
    props: {
        serveHost: String
    },
    data () {
        return {
            publicPath: process.env.BASE_URL,
            book:{}
        }
    },
    created() {
        let bookId = this.$route.params.book_id;
        var _vm = this;
        $.get(_vm.serveHost + '/api/v1/book/' + bookId, (res) => {
            _vm.book = res.data;
        });
    }
}
</script>

<style scoped>
.book-module__group {
    padding: 96px 130px;
}
.book-module__package {
    width: 225px;
    height: 326px;
    float: left;
    margin-right: 125px;
    perspective: 1200;
    -webkit-perspective: 1200;
}
.book-module__info {
    padding-left: 350px;
}
.book-module__thumb {
    position: relative;
    width: 225px;
    height: 326px;
    transform-style: preserve-3d;
    transform: translateZ(-12px) rotateY(0deg);
}
.book-module__thumb .front {
    position: absolute;
    transform: translateZ(12px);
}
.book-module__thumb .front, .book-module__thumb {
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    transition: all .3s ease;
}
.book-module__thumb .side {
    position: absolute;
    width: 24px;
    height: 326px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    transform: translateX(-12px) rotateY(-90deg);
    margin: auto 0;
}
.book-module__thumb .front img {
    max-width: 100%;
    height: 326px;
    transition: all .3s ease;
}
.book-module__info h2 {
    color: rgba(0,0,0,.88);
    font-size: 30px;
    line-height: 38px;
    margin: 0 0 24px;
}
.book-module__info p {
    color: rgba(0,0,0,.56);
    font-size: 14px;
    line-height: 22px;
    word-break: break-all;
    display: -webkit-box;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 8;
    -webkit-box-orient: vertical;
    -moz-box-orient: vertical;
    min-height: 176px;
    margin: 0;
}
.book-module__info>div {
    margin-top: 48px;
}
.book-module__info>div a {
    margin-right: 24px;
}
.bbt-btn.bbt-btn-ghost--primary {
    color: #e00;
    border-color: rgba(238,0,0,.7);
    transition: all .3s ease;
}
.bbt-btn.bbt-btn--primary {
    color: #fff;
    background: #e00;
    border-color: #e00;
    transition: all .3s ease;
}
</style>